import { Entity } from '@/store/shared/entity';
export default class BillOfLading extends Entity<number>{
  /** 文件列表 */
  fileList: Array<any> = new Array<any>();
}